import { MatterFileType, MatterStatus } from '../db-models/matter';

export interface fnCallable {
	getMatterList: string;
	getMatterCSVExport: string;
}

export const fnCallable: fnCallable = {
	getMatterList: 'matterlist_getall',
	getMatterCSVExport: 'matterList_getCSV',
};

export interface GetMatterListRequest {
	filters: Filters;
}

export interface GetMatterCSVExportRequest {
	filters: Filters;
}

export type SelectedDateFilterType = 'closing' | 'createdAt';

export interface Filters {
	fileType?: MatterFileType;
	office?: string;
	lawyer?: string;
	clerk?: string;
	fromDate?: string;
	toDate?: string;
	selectedDateFilter?: SelectedDateFilterType;
	status?: MatterStatus;
	outstandingUndertaking?: boolean;
	outstandingRequisition?: boolean;
}
